









































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Container, Logo, BackButton, Divider, NegativeSubheader } from '../atoms/'
import { SocialBox, SocialConfirmBox } from '../molecules'
import { RegisterBox } from '../organisms'
import {
  REGISTER_MODULE,
  GET_USER_PROVIDERS,
  APPLE_PROVIDER,
  LINE_PROVIDER,
  FACEBOOK_PROVIDER,
  EMAIL_PROVIDER,
  DISPLAY_NAME,
  PROFILE_PICTURE_URL,
  EMAIL_PROVIDER_BINDING,
  USER_EMAIL
} from '../../store/modules/register/constant'
import { required, minLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { passwordRequired, passwordMinLength } from '../../utils/errors'
import {
  AUTH_MODULE,
  REQUEST_SOCIAL_LOGIN,
  PASSWORD_SERVER_ERROR,
  RESET_PASSWORD_ERROR
} from '../../store/modules/auth/constant'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'
import { SocialLoginPayload } from '../../store/api/type'
import translate from '@/language'

@Component({
  components: {
    Container,
    BackButton,
    Logo,
    SocialBox,
    SocialConfirmBox,
    RegisterBox,
    Divider,
    NegativeSubheader
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    }
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [
      APPLE_PROVIDER,
      FACEBOOK_PROVIDER,
      LINE_PROVIDER,
      DISPLAY_NAME,
      USER_EMAIL,
      PROFILE_PICTURE_URL
    ]),
    ...mapGetters(AUTH_MODULE, [PASSWORD_SERVER_ERROR]),
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
  methods: {
    ...mapActions(REGISTER_MODULE, [GET_USER_PROVIDERS, EMAIL_PROVIDER_BINDING]),
    ...mapActions(AUTH_MODULE, [REQUEST_SOCIAL_LOGIN, RESET_PASSWORD_ERROR])
  }
})
export default class EmailProviderBinding extends Vue {
  private password?: string = ''
  private disabledFormSubmitted = false

  @Watch('password')
  onPasswordChange() {
    this.$v.password.$touch()
    ;(this as any)[RESET_PASSWORD_ERROR]()
  }

  mounted() {
    (this as any)[GET_USER_PROVIDERS](this.$route?.query?.challenge)
    this.$nextTick(() => {
      this.$v.$reset()
    })
    ;(this as any)[RESET_PASSWORD_ERROR]()
  }

  get passwordError(): string {
    const { password } = this.$v
    if (this.passwordServerError) {
      return this.passwordServerError
    }
    if (password.$error) {
      if (!password.required) {
        return translate('', 'error-password-required')
      }
      if (!password.minLength) {
        return translate('', 'error-password-min-length')
      }
    }
    return ''
  }
  get appleProvider(): string {
    return (this as any)[APPLE_PROVIDER]
  }
  get lineProvider(): string {
    return (this as any)[LINE_PROVIDER]
  }
  get facebookProvider(): string {
    return (this as any)[FACEBOOK_PROVIDER]
  }
  get emailProvider(): string {
    return (this as any)[EMAIL_PROVIDER]
  }
  get hasProviders(): boolean {
    return this.appleProvider !== '' || this.facebookProvider !== '' || this.lineProvider !== ''
  }
  get displayName(): string {
    return (this as any)[DISPLAY_NAME]
  }
  get userEmail(): string {
    return (this as any)[USER_EMAIL]
  }
  get profilePic(): string {
    return (this as any)[PROFILE_PICTURE_URL]
  }
  get error(): string {
    return this.$route?.query?.error as string
  }
  get isPasswordError(): boolean {
    return this.passwordError !== ''
  }
  get passwordServerError(): string {
    return (this as any)[PASSWORD_SERVER_ERROR]
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isPasswordError
  }
  doProviderBinding() {
    this.$v.$touch()
    if (!this.formError){
      const payload = {
        email: this.userEmail,
        password: this.password,
        challenge: this.$route?.query?.challenge
      }
      return (this as any)[EMAIL_PROVIDER_BINDING](payload)
    }
  }
  async socialBinding(socialType: string) {
    const challenge = this.$route?.query?.challenge
    const payload: SocialLoginPayload = {
      provider: socialType,
      challenge: challenge as string,
      email: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      redirect_url: '',
      action: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      access_token: ''
    }
    this.disabledFormSubmitted = true
    await (this as any)[REQUEST_SOCIAL_LOGIN](payload)
    this.disabledFormSubmitted = false
  }
}
